import React, { useEffect } from 'react';

import styled from 'styled-components';

import { useCountry } from '@lt/localization';

import MobileAppBanner from 'src/components/MobileAppBanner';
import DynamicDataArray from '../DynamicDataArray/DynamicDataArray';
import useDynamicInfo from '../../hooks/useDynamicInfo';

export const DynamicDataWrapper = ({
  fetchLiveInfoPromo,
  liveInfoPromoRequest,
  isMobile,
  isWhitelabel,
  children,
  appLink,
  getDeeplink,
  isWebview,
}) => {
  const { isRussia } = useCountry();
  const {
    currentLatestOrder,
    currentHotPriceByCountry,
    currentFoundToursToday,
  } = useDynamicInfo();

  useEffect(() => {
    if (!appLink) getDeeplink();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dataArrivedSuccessfully =
    liveInfoPromoRequest.isLoading !== null &&
    !liveInfoPromoRequest.isLoading &&
    !liveInfoPromoRequest.isError;

  const latestOrder = currentLatestOrder && {
    title: currentLatestOrder.title,
    descriptions: currentLatestOrder.descriptions,
  };

  const hotPriceByCountry = currentHotPriceByCountry && {
    name: currentHotPriceByCountry.name,
    price: currentHotPriceByCountry.price,
  };

  useEffect(() => {
    fetchLiveInfoPromo();
  }, [fetchLiveInfoPromo]);

  return (
    <Container $isMobile={isMobile} $isWebview={isWebview}>
      <SearcherWrapper $isMobile={isMobile}>
        {children}
        {!isWebview && (
          <SearcherFooter $isMobile={isMobile}>
            {isRussia ? (
              <DynamicDataArray
                foundToursToday={currentFoundToursToday || null}
                latestOrder={latestOrder}
                hotPriceByCountry={hotPriceByCountry}
                isLoading={!dataArrivedSuccessfully}
                isMobile={isMobile}
                isWhitelabel={isWhitelabel}
              />
            ) : null}
            {!isMobile && !isWhitelabel && (
              <AppBannersWrapper>
                <MobileAppBanner appLink={appLink} deviceType="android" />
                <MobileAppBanner appLink={appLink} deviceType="ios" />
              </AppBannersWrapper>
            )}
          </SearcherFooter>
        )}
      </SearcherWrapper>
    </Container>
  );
};

const Container = styled.div<{ $isMobile: boolean; $isWebview: boolean }>`
  font-size: var(--small-text-size);
  width: 100%;
  height: calc(100% - 5em);
  display: flex;
  flex-direction: column;
  justify-content: ${({ $isWebview }) => ($isWebview ? `center` : `flex-end`)};

  & > * + * {
    margin-top: 1em;
  }

  ${({ $isMobile }) =>
    $isMobile
      ? `
        padding: 2em 1.3em;
      `
      : `
        height: 340px;
      `}
`;

const SearcherWrapper = styled.div<{ $isMobile: boolean }>`
  ${({ $isMobile }) =>
    !$isMobile &&
    `
        position: relative;
        background: #17181a;
        border-radius: 6px;
        padding: 10px;
        flex-direction: column;
        justify-content: start;
        pointer-events: all;
        height: 130px;

        /* Перекрываем DesktopAppBanner */
        z-index: 501;
    `}
`;

const SearcherFooter = styled.div<{ $isMobile: boolean }>`
  ${({ $isMobile }) =>
    $isMobile
      ? `
        margin-top: 12px;
        // Не перекрывать CookiesBanner, при этом отображаться перед изображением главной
        z-index: 2;
        position: relative;
    `
      : `
        display: flex;
        margin-top: 8px;
        height: 50px;
    `}
`;

const AppBannersWrapper = styled.div`
  width: 308px;
  display: flex;
  justify-content: space-between;
`;
